import { render } from "./App.vue?vue&type=template&id=dc50c6cc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=dc50c6cc&lang=css"
script.render = render

export default script